<template>
  <div>
    <button @click="reloadRow">Reload row</button>
  </div>
</template>

<script>
export default {
  name: "Actions.vue",
  methods: {
    reloadRow() {
      let row = this.$el.closest('tr');
      let reloadButtons = row.querySelectorAll('button[data-reload-block]');
      reloadButtons.forEach(btn => {
        btn.classList.toggle('group-hover:block');
        btn.classList.toggle('hidden');
        btn.click();
        btn.classList.toggle('group-hover:block');
        btn.classList.toggle('hidden');
      });
    }
  }
}
</script>

<style scoped>

</style>
